import React from "react";
import { FormWrapper } from "../forms/FormWrapper";
import { Button } from "./Button";

export const ConfirmDeleteModal = ({
  onClose,
  onSubmit,
  loading,
  recordName,
  deleteButtonText,
}) => {
  return (
    <FormWrapper>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {loading ? (
          <h2>... wird gelöscht</h2>
        ) : (
          <>
            <h1>{recordName} löschen?</h1>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
            >
              <Button onClick={onClose}>⊘ Abbrechen</Button>
              <Button onClick={onSubmit}>
                {deleteButtonText || "💣 Löschen"}
              </Button>
            </div>
          </>
        )}
      </div>
    </FormWrapper>
  );
};
